import { render, staticRenderFns } from "./StoriesArticleIllustrated.vue?vue&type=template&id=a916d3ca&scoped=true&"
import script from "./StoriesArticleIllustrated.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustrated.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustrated.vue?vue&type=style&index=0&id=a916d3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916d3ca",
  null
  
)

export default component.exports